<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Select a template for email preview</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <slot name="header"></slot>

        <html-snippet-select
          v-model="emailTemplateFooterId"
          :show-preview="true"
          label="Select a footer to preview with"
          snippet-type-filter="EmailTemplateFooter"
          class="mt-6"
        >
       </html-snippet-select>

        <rooftop-select
          v-model="selectedRooftopId"
          :dealer-id="dealerId"
        />

        <dynamic-combobox
          v-model="recipients"
          :initial-items="userEmails"
          class="mt-8"
        >
        </dynamic-combobox>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
      <v-btn color="blue darken-1" text @click="send()">Send</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import DynamicComboBox from '@/components/inputs/DynamicComboBox'
import HtmlSnippetSelect from '@/components/inputs/HtmlSnippetSelect'
import RooftopSelect from '@/components/inputs/RooftopSelect'

export default {
  name: 'send-email-preview-dialog',
  components: {
    [DynamicComboBox.name]: DynamicComboBox,
    [HtmlSnippetSelect.name]: HtmlSnippetSelect,
    [RooftopSelect.name]: RooftopSelect
  },
  props: {
    dealerId: {
      required: true,
      type: [Number, String]
    },
    rooftopId: {
      required: false,
      type: [Number, String]
    },
    emailFooterId: {
      required: false,
      type: [Number, String]
    }
  },
  data: () => ({
    recipients: [],
    emailTemplateFooterId: null,
    selectedRooftopId: null
  }),
  computed: {
    ...mapState('UserStore', ['users']),
    userEmails () {
      return this.users.map(u => u.email)
    }
  },
  watch: {
    rooftopId: {
      immediate: true,
      handler (newVal) {
        this.selectedRooftopId = newVal
      }
    },
    emailTemplateFooterId (newVal, oldVal) {
      this.$emit('selected-footer', newVal)
    },
    emailFooterId: {
      immediate: true,
      handler (newVal) {
      // handle input from component - note - we never emit back...
        if (newVal) {
          this.emailTemplateFooterId = newVal
        }
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    send () {
      this.$emit('send', {
        recipients: this.recipients,
        dealer_rooftop_id: this.selectedRooftopId,
        dealer_id: this.dealerId,
        email_template_footer_id: this.emailTemplateFooterId
      })
    },
    async loadUsers () {
      await this.$store.dispatch('UserStore/fetchUsers')
      const userAttrs = await this.$store.dispatch('getUserAttributes')
      this.recipients.push(userAttrs.email)
    }
  },
  mounted () {
    this.loadUsers()
      .catch(error => this.$emit('error', error.message))
  }
}
</script>
